import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import AttachFileIcon from "@mui/icons-material/AttachFile";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

export default function DialogCampanhaEmailFabricante({
  PaperComponent,
  open,
  onClose,
  emailForm,
  setEmailForm,
  loadingAnexoEmail,
  descarregarAnexoReembolso,
  enviarEmailReembolso,
}) {
  return (
    <Dialog
      PaperComponent={PaperComponent}
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: "calc(100% - 24px)", md: "850px" },
          maxWidth: "100%",
          m: { xs: 1.5, md: 3 },
        },
      }}
    >
      <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
        Enviar ao fabricante
      </DialogTitle>

      <DialogContent
        sx={{
          px: { xs: 1.5, md: 3 },
        }}
      >
        <MDBox display="grid" gap={1.5} mt={1}>
          <MDInput
            label="To"
            value={emailForm.to}
            onChange={(e) => setEmailForm((p) => ({ ...p, to: e.target.value }))}
            fullWidth
          />

          <MDInput
            label="Cc"
            value={emailForm.cc}
            onChange={(e) => setEmailForm((p) => ({ ...p, cc: e.target.value }))}
            fullWidth
          />

          <MDInput
            label="Bcc"
            value={emailForm.bcc}
            onChange={(e) => setEmailForm((p) => ({ ...p, bcc: e.target.value }))}
            fullWidth
          />

          <MDInput
            label="Assunto"
            value={emailForm.assunto}
            onChange={(e) => setEmailForm((p) => ({ ...p, assunto: e.target.value }))}
            fullWidth
          />

          <MDInput
            label="Mensagem"
            multiline
            rows={6}
            value={emailForm.mensagem}
            onChange={(e) => setEmailForm((p) => ({ ...p, mensagem: e.target.value }))}
            fullWidth
          />

          <MDBox
            mt={2}
            display="flex"
            alignItems={{ xs: "flex-start", sm: "center" }}
            flexDirection={{ xs: "column", sm: "row" }}
            gap={0.5}
          >
            <AttachFileIcon fontSize="small" />
            <MDTypography variant="caption">
              Anexo: ficheiro Excel da campanha será gerado automaticamente.
            </MDTypography>
          </MDBox>
        </MDBox>
      </DialogContent>

      <DialogActions
        sx={{
          flexWrap: "wrap",
          gap: 1,
          px: { xs: 2, md: 3 },
          pb: { xs: 2, md: 2 },
          "& .MuiButton-root": {
            width: { xs: "100%", sm: "auto" },
          },
        }}
      >
        <MDButton color="secondary" onClick={onClose}>
          Cancelar
        </MDButton>

        <MDButton color="info" onClick={descarregarAnexoReembolso} disabled={loadingAnexoEmail}>
          {loadingAnexoEmail ? "A gerar anexo..." : "Ver anexo"}
        </MDButton>

        <MDButton color="success" onClick={enviarEmailReembolso}>
          Enviar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
